import React, { useState, useEffect } from 'react';
import {
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Badge,
} from 'reactstrap';
import { useAuth } from '../../Context/AuthContext';
import logo from './wocon.png';
import { ExitToApp as ExitToAppIcon, HolidayVillage } from '@mui/icons-material';
import { Avatar } from '@mui/material';
import EventNoteIcon from '@mui/icons-material/EventNote';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import { useNavigate } from 'react-router-dom';

interface HeaderProps {
  selectedProject?: { projectName: string };
}

function Header({ selectedProject }: HeaderProps) {
  const { role, name } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [animate, setAnimate] = useState(false);
  const navigate = useNavigate();

  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    setTimeout(() => setAnimate(true), 1);
  }, []);

  const getRoleBadge = (role: string) => {
    switch (role) {
      case 'Admin':
        return <Badge color="danger" className="ms-2">Admin</Badge>;
      case 'ProjectManager':
        return <Badge color="info" className="ms-2">Project Manager</Badge>;
      case 'TeamLeader':
        return <Badge color="warning" className="ms-2 text-dark">Team Lead</Badge>;
      case 'TeamMember':
        return <Badge color="success" className="ms-2">Team Member</Badge>;
      case 'Client':
        return <Badge color="primary" className="ms-2">Client</Badge>;
      default:
        return null;
    }
  };

  const goToDashboard = () => {
    if (role === "Admin") {
      navigate("/Admin");
    } else if (role === "ProjectManager") {
      navigate("/Project");
    } else if (role === "TeamLeader") {
      navigate("/TeamLead");
    } 
    else if (role === "Client") {
      navigate("/client");
    }
    else {
      navigate("/Member");
    }
  };


  const generateInitials = (name: string) =>
    name
      .split(' ')
      .filter(Boolean)
      .map(n => n[0])
      .join('')
      .toUpperCase();

  return (
    <Navbar
      expand="md"
      dark
      style={{
        background: 'linear-gradient(to right, #003366, #0059b3)',
        padding: '0.75rem 1.5rem',
      }}
      className={`header-navbar shadow-lg ${animate ? 'slide-in' : ''}`}
    >
      {/* Left: Logo */}
      <NavbarBrand
        onClick={goToDashboard}
        style={{ cursor: "pointer" }}
        className="fw-bold text-white fs-3 d-flex align-items-center"
      >

        <img
          src={logo}
          alt="Logo"
          style={{ width: '110px', height: '50px' }}
        />
       AppsPro
      </NavbarBrand>

      {/* Center: Project Name */}
      <div className="mx-auto text-center text-white fw-bold fs-5">
        {selectedProject ? selectedProject.projectName : ""}
      </div>

      <NavbarToggler onClick={toggle} className="border-0" />

      {/* Right: User Info */}
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ms-auto align-items-center gap-4" navbar>
          {!role ? (
            <NavItem>
              <NavLink href="/login" className="nav-link-animated"></NavLink>
            </NavItem>
          ) : (
            <>
              {["Admin"].includes(role) && (
                <NavItem>
                  <NavLink href='/OverallLog' className='nav-link-animated'>
                    <ManageHistoryIcon /> Log
                  </NavLink>
                </NavItem>
              )}
              {role !=="Client" &&
              (<>
<NavItem>
                <NavLink href='/WorkSheet' className='nav-link-animated'>
                  <EventNoteIcon />  WorkSheet
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href='/leave' className='nav-link-animated'>
                  <HolidayVillage />  Leave
                </NavLink>
              </NavItem>
              </>)}
              
              <NavItem>
                <NavLink href="/profile" className="nav-link-animated">
                  <div className="d-flex align-items-center">
                    <Avatar
                      sx={{
                        width: 30,
                        height: 30,
                        fontSize: 13,
                        color: '#fff',
                        fontWeight: 'bold',
                        backgroundColor: '#0d6efd',
                      }}
                    >
                      {generateInitials(name || '')}
                    </Avatar>
                    <small className="text-light">{getRoleBadge(role)}</small>
                  </div>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href="/logout"
                  className="nav-link-animated text-white d-flex align-items-center"
                  style={{ transition: '0.2s ease' }}
                >
                  <ExitToAppIcon fontSize="small" className="me-1" />
                  <b>Logout</b>
                </NavLink>
              </NavItem>
            </>
          )}
        </Nav>
      </Collapse>
    </Navbar>
  );
}

export default Header;
